export default class Constants {
  public static NewId = -1;

  public static LinkedToInflation = "LinkedToInflation";

  public static LoginResouce = "/login";

  public static AdminRoles = ["admin", "userviewer"];

  public static MaxPlanYears = 40;

  public static IncomeStepSize = 100;

  public static MinAnnualIncome = 7200;
  public static MaxAnnualIncome = 250000;

  public static InflationDurationForLife = "Life";

  public static ChartDataWhatYouWantSeriesName = "What you want after tax";
  public static ChartDataShortfallSeriesName = "Expected shortfall";
  public static PotsChartDataSavingsSeriesName = "Savings";
  public static PotsChartDataPensionPotsSeriesName = "Defined Contribution Pension Pots"

  public static TaxFreeLumpSumPercentage = 25;
  public static TaxFreeCashLimit = 268275;

  public static RegularExpressions = class {
    public static Email = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    public static EmailChars = /[a-z0-9_@.+-]/;
    public static Password = /^(?=.*\d).{8,}$/;
    public static PasswordDescription = "The password must be at least 8 characters long and contain at least one number.";
    public static PhoneNumber = /^\+?\d(?: ?\d){6,14}$/;
    public static PhoneNumberChars = /^[0-9 ]$|^\+$/;
    public static FinalSalarySchemeCode = /^[a-z0-9]{2,}$/;
    public static FinalSalarySchemeCodeChars = /[a-z0-9]/;
  }

  public static Product = class {
    public static Name = "GuiidePath";
    public static MinEligibleAge = 50;
    public static MatchedYearsMin = 0;
    public static MatchedYearsMax = 40;
  }

  public static Color = class {
    public static barChartDefault = '#556270';
    public static amber = '#FFBF00';
    public static ameline = '#7c0096';
    public static bitterLimeDesaturated = '#8fb814';
    public static oliveOil = '#ccaa00';
    public static lightEmerald = '#009463';
    public static brunswickGreen = '#004C33';    
    public static classicgold = '#FFD700';
  }

  public static Config = class {
    public static AdditionalInfoKeys = class {
      public static email = 'email';
      public static token = 'token';
      public static confirmAccountErrors = 'confirmAccountErrors';
    }
  }

  public static Temporal = class {
    public static Months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    public static MarchAsJSDateNumber = 2;
    public static AprilAsJSDateNumber = 3;
  }

  public static HelpTextTokens = class {
    public static numberOfExtraYearsInLiveLongerTest = "[[EXTRA_YEARS_LIVE_LONGER_TEST]]";
  }
}
